export const UPDATE_INPUT = 'UPDATE_INPUT';
export const UPDATE_RECEIPT_ID = 'UPDATE_RECEIPT_ID';
export const UPDATE_ADD_INPUT = 'UPDATE_ADD_INPUT';
export const UPDATE_ADD_CONF = 'UPDATE_ADD_CONF';
export const RESET_ADD_CONF = 'RESET_ADD_CONF';
export const CHANGE_MODIFY_MODE = 'CHANGE_MODIFY_MODE';
export const CHANGE_VALID = 'CHANGE_VALID';
export const ADD_REGISTER = 'ADD_REGISTER';
export const REGISTER = 'REGISTER';